module.exports = __webpack_public_path__ + "img/5.6aa73b6e.png";